/* eslint-disable import/prefer-default-export */
export const GET_USERS_FROM_CRM_URL = `http://my9ja.com/restapi/crm.php`;
